export function nopropagation(event) {
  event.stopImmediatePropagation();
}

export default function(event) {
  event.preventDefault();
  event.stopImmediatePropagation();
}



//////////////////
// WEBPACK FOOTER
// ./~/d3-zoom/src/noevent.js
// module id = 751
// module chunks = 0